import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Typography,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import React from 'react';
import { Add, Minimize } from '@mui/icons-material';
import { Link } from 'react-router-dom';

export const Questions = () => {
  const { breakpoints } = useTheme();
  const isDesktop = useMediaQuery(breakpoints.up('lg'));
  const isMobile = useMediaQuery(breakpoints.down('sm'));

  const [expanded, setExpanded] = React.useState<string | false>(false);

  const handleChange =
    (panel: string) => (event: React.SyntheticEvent, newExpanded: boolean) => {
      setExpanded(newExpanded ? panel : false);
    };

  const color = {
    color: 'black',
  };

  return (
    <Box
      sx={{
        display: 'grid',
        placeItems: 'center',
        paddingLeft: '40px',
        paddingRight: '40px',
      }}
    >
      <Typography
        component="h2"
        sx={{
          fontSize: isMobile ? '20px' : '32px',
          color: '#212121',
          fontWeight: 700,
          textAlign: 'center',
        }}
      >
        Preguntas frecuentes
      </Typography>
      <Box
        sx={{
          width: isDesktop ? '1140px' : isMobile ? '100%' : '688px',
          marginTop: '16px',
        }}
      >
        <Accordion
          expanded={expanded === 'panel1'}
          onChange={handleChange('panel1')}
          disableGutters={true}
          elevation={0}
        >
          <AccordionSummary
            expandIcon={
              expanded === 'panel1' ? (
                <Minimize sx={{ color }} />
              ) : (
                <Add sx={{ color }} />
              )
            }
          >
            <Typography
              sx={{ fontSize: '16px', fontWeight: 700, color: '#595959' }}
            >
              ¿Que no debo hacer si choqué?
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography
              sx={{
                color: '#595959',
                fontWeight: 400,
                fontSize: '14px',
                lineHeight: '17.07px',
                textAlign: 'justify',
              }}
            >
              Nunca hagas esto, ¿ok?
              <ul>
                <li>
                  Definitivamente no entres en arreglos de ningún tipo con quien
                  chocaste hasta que tu ajustador asignado te diga qué onda. Tal
                  vez te sientas moralmente responsable, ¡pero puede ser que
                  para nada lo seas! Así que... ¡paciencia!
                </li>
                <li>
                  Que ni se te ocurra intentar cambiar conductores o manipular
                  lo que pasó, porque puede ser mucho peor... Esto sólo hace que
                  todo sea más lento y podría pasar que tu aseguradora te diga
                  que no puede apoyarte.
                </li>
              </ul>
              Si el otro coche huye, por nada del mundo intentes alcanzarlo ni
              detenerlo, POR TU SEGURIDAD. ¡Uno nunca sabe lo que puede pasar!
              Mejor anota sus placas, el tipo y el color del vehículo si puedes.
            </Typography>
          </AccordionDetails>
        </Accordion>
        <Box
          sx={{
            border: '0.508027px solid #595959',
            transform: 'scaleY(0.5)',
            width: '100%',
          }}
        ></Box>
        <Accordion
          expanded={expanded === 'panel2'}
          onChange={handleChange('panel2')}
          disableGutters={true}
          elevation={0}
        >
          <AccordionSummary
            expandIcon={
              expanded === 'panel2' ? (
                <Minimize sx={{ color }} />
              ) : (
                <Add sx={{ color }} />
              )
            }
          >
            <Typography
              sx={{ fontSize: '16px', fontWeight: 700, color: '#595959' }}
            >
              Choqué... ¿¡y ahora!?
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography
              sx={{
                color: '#595959',
                fontWeight: 400,
                fontSize: '14px',
                lineHeight: '17.07px',
                textAlign: 'justify',
              }}
            >
              Lo primerisimo es respirar hondo. ¿Estás bien? ¿Hay lesionados?
              Sabemos que es un momento horrible y medio de pesadilla, pero
              intenta mantener la calma es súper importante. Llámale a tu
              aseguradora y ten a la mano la siguiente info:
              <ul>
                <li>Tu número de póliza</li>
                <li>El lugar exacto del accidente. ¡Usa tu GPS!</li>
                <li>Tu teléfono por si es necesario echarte una llamadita</li>
                <li>Marca, tipo, color y placas de tu coche</li>
                <li>El nombre de quien iba conduciendo</li>
                <li>Si hay o no algún lesionado</li>
              </ul>
              Recomendaciones:
              <ul>
                <li>Cuenta cómo fue que pasó todo sin echar mucho rollo</li>
                <li>
                  Pídele a tu aseguradora el nombre del ajustador que te va a
                  apoyar, y anota el número de siniestro y la hora a la que
                  llamaste
                </li>
                <li>
                  Si alguien del accidente necesita atenación médica, pídele un
                  pase médico al ajustador.
                </li>
                <li>
                  Si tu coche ya no se puede mover por los daños de choque, el
                  ajustador le echará un telefonazo a la grúa para que se lleve
                  tu coche a reparar.
                </li>
              </ul>
            </Typography>
          </AccordionDetails>
        </Accordion>
        <Box
          sx={{
            border: '0.508027px solid #595959',
            transform: 'scaleY(0.5)',
            width: '100%',
          }}
        ></Box>
        <Accordion
          expanded={expanded === 'panel3'}
          onChange={handleChange('panel3')}
          disableGutters={true}
          elevation={0}
        >
          <AccordionSummary
            expandIcon={
              expanded === 'panel3' ? (
                <Minimize sx={{ color }} />
              ) : (
                <Add sx={{ color }} />
              )
            }
          >
            <Typography
              sx={{ fontSize: '16px', fontWeight: 700, color: '#595959' }}
            >
              ¿Qué hago si es pérdida total? :(
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography
              sx={{
                color: '#595959',
                fontWeight: 400,
                fontSize: '14px',
                lineHeight: '17.07px',
                textAlign: 'justify',
              }}
            >
              Si te llega a pasar una Pérdida Total por Daños Materiales o por
              Robo Total, junta todos los documentos que te pida tu aseguradora
              para ver qué onda con la indemnización. Obvio, todo depende de las
              Condiciones Generales de tu Póliza.
              <br></br>
              <br></br>
              Aquí están las guías de las aseguradoras y las checklists de los
              documentos que necesitas para hacer tu trámite de Pérdida Total
              por Daños Materiales y/o Robo Total de tu coche.
            </Typography>
            <Box marginBottom={2} />
            <Typography
              sx={{
                color: '#595959',
                fontWeight: 400,
                fontSize: '14px',
                lineHeight: '17.07px',
                textAlign: 'justify',
              }}
            >
              Quálitas:
              <Link
                to={{
                  pathname: '',
                }}
                target="_blank"
              >
                <Typography
                  color={'#039ECC'}
                  sx={{ textDecoration: 'underline' }}
                >
                  Documentación de pérdida total <br></br>Guía de pérdida total{' '}
                  <br></br>Guía de robo total <br></br>Contrato de compra-venta
                </Typography>
              </Link>
            </Typography>
            <Box marginBottom={2} />
            <Typography
              sx={{
                color: '#595959',
                fontWeight: 400,
                fontSize: '14px',
                lineHeight: '17.07px',
                textAlign: 'justify',
              }}
            >
              MAPFRE:
              <Link
                to={{
                  pathname: '',
                }}
                target="_blank"
              >
                <Typography
                  color={'#039ECC'}
                  sx={{ textDecoration: 'underline' }}
                >
                  Guía de daños materiales por pérdida total <br></br>
                  Guía de robo total
                </Typography>
              </Link>
            </Typography>
            <Box marginBottom={2} />
            <Typography
              sx={{
                color: '#595959',
                fontWeight: 400,
                fontSize: '14px',
                lineHeight: '17.07px',
                textAlign: 'justify',
              }}
            >
              HDI:
              <Link
                to={{
                  pathname: '',
                }}
                target="_blank"
              >
                <Typography
                  color={'#039ECC'}
                  sx={{ textDecoration: 'underline' }}
                >
                  Checklist de documentación
                </Typography>
              </Link>
            </Typography>
            <Box marginBottom={2} />
            <Typography
              sx={{
                color: '#595959',
                fontWeight: 400,
                fontSize: '14px',
                lineHeight: '17.07px',
                textAlign: 'justify',
              }}
            >
              GNP:
              <Link
                to={{
                  pathname: '',
                }}
                target="_blank"
              >
                <Typography
                  color={'#039ECC'}
                  sx={{ textDecoration: 'underline' }}
                >
                  Checklist de documentación
                </Typography>
              </Link>
            </Typography>
            <Box marginBottom={2} />
            <Typography
              sx={{
                color: '#595959',
                fontWeight: 400,
                fontSize: '14px',
                lineHeight: '17.07px',
                textAlign: 'justify',
              }}
            >
              Chubb:
              <Link
                to={{
                  pathname: '',
                }}
                target="_blank"
              >
                <Typography
                  color={'#039ECC'}
                  sx={{ textDecoration: 'underline' }}
                >
                  Checklist de documentación
                </Typography>
              </Link>
            </Typography>
            <Box marginBottom={2} />
            <Typography
              sx={{
                color: '#595959',
                fontWeight: 400,
                fontSize: '14px',
                lineHeight: '17.07px',
                textAlign: 'justify',
              }}
            >
              Primero Seguros:
              <Link
                to={{
                  pathname: '',
                }}
                target="_blank"
              >
                <Typography
                  color={'#039ECC'}
                  sx={{ textDecoration: 'underline' }}
                >
                  Guía de pérdida total
                </Typography>
              </Link>
            </Typography>
            <Box marginBottom={2} />
            <Typography
              sx={{
                color: '#595959',
                fontWeight: 400,
                fontSize: '14px',
                lineHeight: '17.07px',
                textAlign: 'justify',
              }}
            >
              Zurich:
              <Link
                to={{
                  pathname: '',
                }}
                target="_blank"
              >
                <Typography
                  color={'#039ECC'}
                  sx={{ textDecoration: 'underline' }}
                >
                  Checklist de documentación
                </Typography>
              </Link>
            </Typography>
            <Box marginBottom={2} />
            <Typography
              sx={{
                color: '#595959',
                fontWeight: 400,
                fontSize: '14px',
                lineHeight: '17.07px',
                textAlign: 'justify',
              }}
            >
              AIG:
              <Link
                to={{
                  pathname: '',
                }}
                target="_blank"
              >
                <Typography
                  color={'#039ECC'}
                  sx={{ textDecoration: 'underline' }}
                >
                  Checklist de documentación
                </Typography>
              </Link>
            </Typography>
          </AccordionDetails>
        </Accordion>
        <Box
          sx={{
            border: '0.508027px solid #595959',
            transform: 'scaleY(0.5)',
            width: '100%',
          }}
        ></Box>
        <Accordion
          expanded={expanded === 'panel4'}
          onChange={handleChange('panel4')}
          disableGutters={true}
          elevation={0}
        >
          <AccordionSummary
            expandIcon={
              expanded === 'panel4' ? (
                <Minimize sx={{ color }} />
              ) : (
                <Add sx={{ color }} />
              )
            }
          >
            <Typography
              sx={{ fontSize: '16px', fontWeight: 700, color: '#595959' }}
            >
              ¿Qué hacer en caso de que me roben mi vehículo?
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography
              sx={{
                color: '#595959',
                fontWeight: 400,
                fontSize: '14px',
                lineHeight: '17.07px',
                textAlign: 'justify',
              }}
            >
              ¿Y si se robaron mi coche? :(
              <ul>
                <li>¡Échale un telefonazo al 911 (antes 066) y repórtalo!</li>
                <li>
                  Denuncia de inmediato en la Fiscalía (antes Ministerio
                  Público).
                </li>
                <li>
                  También haz una llamadita a tu aseguradora para reportar el
                  robo.
                </li>
                <li>
                  Cuando ya hayas hecho todo esto, tu aseguradora te dirá qué
                  onda.
                </li>
              </ul>
              Levanta denuncias ante las autoridades
              <ul>
                <li>
                  Obtén una copia certificada de la constancia que te expida la
                  Guardia Nacional
                </li>
                <li>
                  También necesitas la copia certificada de la constancia que
                  expida la autoridad de Policía Y Tránsito o Policia Judicial
                  de los diversos estados o municipios de la que expide esta
                  constancia.
                </li>
              </ul>
              Da flojera,{' '}
              <b>
                ¡pero es súper importante que avises en la Fiscalía sobre el
                robo!
              </b>
              <Box marginBottom={2} />
              No olvides llevar los documentos para comprobar que ese coche sí
              es tuyo. Checa desde antes que estén bien, por cualquier cosa.
              <Box marginBottom={2} />
              Ésto segurito te lo van a pedir:
              <ul>
                <li>Tipo de unidad</li>
                <li>Modelo</li>
                <li>Año</li>
                <li>Serie</li>
                <li>Motor</li>
                <li>Placas</li>
              </ul>
            </Typography>
          </AccordionDetails>
        </Accordion>
        <Box
          sx={{
            border: '0.508027px solid #595959',
            transform: 'scaleY(0.5)',
            width: '100%',
          }}
        ></Box>
        <Accordion
          expanded={expanded === 'panel5'}
          onChange={handleChange('panel5')}
          disableGutters={true}
          elevation={0}
        >
          <AccordionSummary
            expandIcon={
              expanded === 'panel5' ? (
                <Minimize sx={{ color }} />
              ) : (
                <Add sx={{ color }} />
              )
            }
          >
            <Typography
              sx={{ fontSize: '16px', fontWeight: 700, color: '#595959' }}
            >
              Tuve un accidente y lastimé a alguien, ¡ayuda! ¿Que hago?
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography
              sx={{
                color: '#595959',
                fontWeight: 400,
                fontSize: '14px',
                lineHeight: '17.07px',
                textAlign: 'justify',
              }}
            >
              Primeritito, respira hondo. Intenta mantener la calma es súper
              importante. ¡No intentes huir! Ve cómo está la persona lesionada y
              checa a simple vista si es de gravedad. Llama inmediatamente una
              ambulancia. A la par, échale un telefonazo a tu aseguradora para
              reportarle lo que pasó y que un ajustador acuda a donde fue el
              accidente
              <Box marginBottom={2} />
              Recomendaciones
              <ul>
                <li>
                  Por nada del mundo toques o muevas a la persona lesionada.
                </li>
                <li>
                  No aceptes ninguna responsabilidad hasta que llegue tu
                  ajustadory te diga qué onda y los pasos a seguir
                </li>
              </ul>
            </Typography>
          </AccordionDetails>
        </Accordion>
        <Box
          sx={{
            border: '0.508027px solid #595959',
            transform: 'scaleY(0.5)',
            width: '100%',
          }}
        ></Box>
      </Box>
      <Box sx={{ marginBottom: 20 }}></Box>
      {/*
        ********Se oculta por el momento este enlace hasta nuevo aviso******     
      <Box
        sx={{
          marginBottom: '80px',
          display: 'flex',
          flexDirection: isMobile ? 'column' : 'row',
          textAlign: 'center',
          marginTop: '16px',
        }}
      >
        <Typography
          sx={{
            fontSize: '16px',
            fontWeight: 400,
            color: '#0A3949',
          }}
        >
          Para más info consulta nuestra sección de{' '}
        </Typography>
        <Link
          to={{
            pathname: '',
          }}
          target="_blank"
        >
          <Typography
            color={'#009DD0'}
            paddingLeft={'4px'}
            sx={{ textDecoration: 'underline' }}
          >
            preguntas frecuentes
          </Typography>
        </Link>
        </Box>*/}
    </Box>
  );
};
